<template>
  <div class="balance-card">
    <!-- Skeleton Loader -->
    <div v-if="loading" class="skeleton-loader">
      <div class="skeleton-header">
        <div class="skeleton-text skeleton-label"></div>
      </div>

      <div class="skeleton-amount-container">
        <div class="skeleton-text skeleton-amount"></div>
        <div class="skeleton-toggle"></div>
      </div>

      <div class="skeleton-divider"></div>

      <div class="skeleton-actions">
        <div class="skeleton-button skeleton-button-primary"></div>
        <div class="skeleton-button skeleton-button-secondary"></div>
      </div>
    </div>

    <!-- Actual Content -->
    <div v-else>
      <div class="balance-header">
        <p class="balance-label">Available Balance</p>
      </div>

      <div class="balance-amount-container">
        <h1 class="balance-amount">IDR {{ formattedBalance }}</h1>
        <div class="visibility-toggle" @click="toggleVisibility">
          <i v-if="visible" class="fas fa-eye-slash eye-icon"></i>
          <i v-else class="fas fa-eye eye-icon"></i>
        </div>
      </div>

      <div class="divider"></div>

      <div class="actions">
        <button class="add-balance-btn" @click="$router.push('/balance')">
          <span class="plus-icon">+</span>
          Add Balance
        </button>
        <button class="statement-btn" @click="$router.push('/balance')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            ></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          Statement
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BalanceCard",
  data() {
    return {
      visible: true,
    };
  },
  props: {
    balance: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedBalance() {
      if (!this.visible) return "••••••••••••";
      return this.balance.toLocaleString("id-ID");
    },
  },
  methods: {
    toggleVisibility() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style scoped>
.balance-card {
  background-color: white;
  border-radius: 20px;
  padding: 32px;
  width: 100%;
  max-width: 100%;
}

.balance-label {
  color: #000;
  font-size: 16px;
  margin: 0 0 8px 0;
  font-weight: 400;
}

.balance-amount-container {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.balance-amount {
  font-size: 42px;
  font-weight: bold;
  margin: 0;
  letter-spacing: -0.5px;
}

.visibility-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  margin-left: 16px;
  cursor: pointer;
  color: #777;
}

.divider {
  height: 1px;
  background-color: #e0e0e0;
  margin-bottom: 24px;
}

.actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.add-balance-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #43bb75;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.plus-icon {
  margin-right: 8px;
  font-size: 18px;
  font-weight: bold;
}

.statement-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(93, 176, 117, 0.1);
  color: #5db075;
  border: none;
  border-radius: 50px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.statement-btn svg {
  margin-right: 8px;
}

/* Skeleton Loader Styles */
.skeleton-loader {
  animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
}

.skeleton-label {
  width: 140px;
  height: 20px;
  margin-bottom: 8px;
}

.skeleton-amount-container {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.skeleton-amount {
  width: 280px;
  height: 50px;
  margin-right: 16px;
}

.skeleton-toggle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-divider {
  height: 1px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 24px;
}

.skeleton-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.skeleton-button {
  height: 52px;
  border-radius: 50px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-button-primary {
  width: 150px;
}

.skeleton-button-secondary {
  width: 120px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
</style>
